const globalPlaceholder = {
  searchPlaceHolder: "Search",
  searchTypesDropdown: "Search",
  quickSearchPlaceHolder: "Quick Search",
  pleaseSelect: "Please select",
  countryPlaceholder: "Please select country",
  subAccountPlaceholder: "Select Sub Account",
  statePlaceholder: "Please select state",
};

export default globalPlaceholder;
